// extracted by mini-css-extract-plugin
export default {"modal-link":"_1045Q","modalLink":"_1045Q"};